export default "__VITE_ASSET__CpfwUHvX__"